module.exports = __webpack_public_path__ + "img/2.62874a35.png";